
    import Vue from 'vue';
    import saveEmissionService from '../../../shared/services/saveEmission-service';
    import getSelectedProducerService from '../../../shared/services/selectedProducer-service';
    export default Vue.extend({
        el: '#step2',
        name: 'TabTwo',
        data() {
            return {
                modeloDispositivo: null,
                marcaDispositivo: null,
                goodSelected: null,
                stepOneData: null,
                DataGood: null,
                goodId: null,
                marcaDispositivoInvalid: false,
                clientCode: "0",
                originId: 4,
                producerDataLoaded: false,
            }
        },
        methods: {
            validate: function (config, direction) {
                var timeStart = new Date();
                sessionStorage.setItem("TimeStart", JSON.stringify(timeStart));
                if (direction == "backward") {
                    document.getElementById("Siguiente").style.visibility = "visible"
                }
                var formIsValid = NF.Validation.Form.validate('#form2Client');
                if (!formIsValid) {
                    return formIsValid;
                }
                if (direction != "backward" && this.marcaDispositivo != null) {
                    this.SaveEmission();
                }
                else {
                    if (this.marcaDispositivo == null) {
                        window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'errorUsuario', 'paso': 'cotizador-tecnologia-datos-equipo' });
                        this.marcaDispositivoInvalid = true;
                        return false;
                    }
                    return formIsValid;
                }
            },

            validMarca: function () {
                this.marcaDispositivo != null ? this.marcaDispositivoInvalid = false : true;
            },

            showRuletaErrorModal(show) {
                if (show) {
                    this.$refs.modalErrorRuleta.open();
                }
                else {
                    this.$refs.modalErrorRuleta.close();
                }
            },

            retryEmission() {
                sessionStorage.removeItem("producerData");
                this.producerDataLoaded = false;
                this.showRuletaErrorModal(false);
                this.startProducerDataTask()
                this.SaveEmission();

            },

            startProducerDataTask() {
                return new Promise((resolve, reject) => {
                    this.stepOneData = JSON.parse(sessionStorage.getItem("stepOneData"));
                    if (this.stepOneData != null) {
                        getSelectedProducerService.GetSelectedProducer(
                            this.clientCode,
                            this.stepOneData.localityId,
                            0,
                            this.originId,
                            this.stepOneData.zipCode
                        ).then(producerData => {
                            sessionStorage.setItem("producerData", JSON.stringify(producerData));
                            this.producerDataLoaded = true;
                            resolve(true);
                        }).catch(error => {
                            this.showRuletaErrorModal(true);
                            reject(error);
                        });
                    }
                });
            },

            waitForProducerData() {
                return new Promise((resolve, reject) => {
                    const timeout = setTimeout(() => {
                        this.showRuletaErrorModal(true);
                        reject(new Error("Timeout: Ruleta respondio en mas de 1 minuto"));
                    }, 60000); // espera 1 minuto y tira timeout de ruleta

                    const checkProducerDataLoaded = () => {
                        if (this.producerDataLoaded) {
                            clearTimeout(timeout); // Limpia el timeout si los datos se cargan a tiempo
                            resolve(true);
                        } else {
                            setTimeout(checkProducerDataLoaded, 200); // Vuelve a verificar después de 200ms
                        }
                    };

                    checkProducerDataLoaded();
                });
            },

            SaveEmission() {
                this.waitForProducerData().then(() => {
                    var DataGood = JSON.parse(sessionStorage.getItem("DataGood"));
                    DataGood = { ...DataGood, goodBrand: this.marcaDispositivo, goodModel: this.modeloDispositivo }
                    sessionStorage.setItem("DataGood", JSON.stringify(DataGood));

                    const producerData = JSON.parse(sessionStorage.getItem("producerData"));
                    if (!producerData) {
                        NF.UI.Page.unblock();
                        this.showRuletaErrorModal(true);
                        return;
                    }

                    const birthDay = this.stepOneData.birthDay || "01/01/1900";
                    const dateFormat = new Date(birthDay);
                    const JsonEmissionData = JSON.stringify({
                        birthday: dateFormat,
                        cityCode: parseInt(this.stepOneData.localityId),
                        clientAddress: {
                            department: this.stepOneData.numDept == null ? "" : this.stepOneData.numDept.toString(),
                            floor: parseInt(this.stepOneData.piso == null ? 0 : this.stepOneData.piso),
                            streetName: this.stepOneData.streetName == null ? "" : this.stepOneData.streetName.toString(),
                            streetNumber: this.stepOneData.numDom == null ? "" : this.stepOneData.numDom.toString(),
                        },
                        clientFirstName: this.stepOneData.firstName ? this.stepOneData.firstName.toString() : "",
                        clientLastName: this.stepOneData.lastName ? this.stepOneData.lastName.toString() : " ",
                        documentNumber: parseInt(this.stepOneData.documentNumber),
                        documentType: this.stepOneData.documentType.id.trim(),
                        email: this.stepOneData.email ? this.stepOneData.email.toString() : null,
                        phones: [{
                            areaCode: this.stepOneData.telephone ? parseInt(this.stepOneData.areaCode) : null,
                            countryCode: this.stepOneData.telephone ? parseInt(this.stepOneData.telephone[0].countryCode) : null,
                            order: this.stepOneData.telephone ? parseInt(this.stepOneData.telephone[0].order) : null,
                            phoneNumber: this.stepOneData.telephone ? this.stepOneData.telephone.toString() : "",
                            phoneType: this.stepOneData.telephone ? parseInt(this.stepOneData.telephone[0].phoneType) : null
                        }],
                        zipCode: this.stepOneData.zipCode,
                        insuredGoodDetail: {
                            BrandDescription: this.marcaDispositivo,
                            InsuredGoodDescription: this.goodSelected,
                            InsuredGoodId: this.goodId,
                            ModelDescription: this.modeloDispositivo,
                        },
                    });

                    saveEmissionService.TheftElectronicDeviceSaveEmission(JsonEmissionData).then(response => {
                        if (response.validationResult.errorMessage === "Los datos para la emisión se guardaron correctamente") {
                            NF.UI.Page.block();
                            sessionStorage.setItem("ExitOrContinueModal", "false");
                            window.parent.location.href = '/tecnologia/resumen';
                        } else {
                            this.showRuletaErrorModal(true);
                        }
                    }).catch(error => {
                        NF.UI.Page.unblock();
                        this.showRuletaErrorModal(true);
                    });
                }).catch((error) => {
                    NF.UI.Page.unblock();
                    this.showRuletaErrorModal(true);

                });
            }
        },

        watch: {
            SelectedNotebook(newVal) {
                if (newVal) {
                    return this.validNotebook = true
                }
                else {
                    return this.validNotebook = false
                }
            },
            SelectedAuricular(newVal) {
                if (newVal) {
                    return this.validAuricular = true
                }
                else {
                    return this.validAuricular = false
                }
            },
            SelectedCelular(newVal) {
                if (newVal) {
                    return this.validCelular = true
                }
                else {
                    return this.validCelular = false
                }
            },
            SelectedTablet(newVal) {
                if (newVal) {
                    return this.validTablet = true
                }
                else {
                    return this.validTablet = false
                }
            }
        },
        mounted() {
            this.Bus.$on('get-step-two-data', () => this.Bus.$emit('step-two-data', this.$data))
            var DataGood = sessionStorage.getItem("DataGood");
            if (DataGood != null) {
                this.DataGood = JSON.parse(DataGood!);
                this.goodSelected = this.DataGood.goodTypeDescription;
                this.goodId = this.DataGood.goodTypeId;
            };
            this.startProducerDataTask();

            NF.UI.Page.block();

            setTimeout(() => {
                NF.UI.Page.unblock();
            }, 2000); // Espera de 2 segundos
        },
    });
